import { StringConstants } from "global/constants/StringConstants";

// R-177: the environment is chosen at build time, not by sed-editing this file. Create React App inlines
// REACT_APP_ENV as a literal, so in a production build each `PROD ? prod : uat` below folds to its
// production branch and the UAT hosts are dropped from the bundle; the production buildspec checks that
// with scripts/r177-check-prod-bundle.sh. Anything other than "prod" (including unset) builds against UAT.
const PROD = process.env.REACT_APP_ENV === "prod";

class UrlConstants extends StringConstants {
  PROD = PROD;

  url_prod = "https://api.inkfree.app/";
  // url_dev = "http://localhost:6050/";
  // url_dev = "http://localhost:6040/";

  url = (PROD ? this.url_prod : "https://api-uat.inkfree.app/") + "crm";
  url_core =
    (PROD
      ? this.url_prod
      : "https://api-uat.inkfree.app/".includes("uat")
        ? "https://api-uat.inkfree.app/"
        : "http://localhost:6040/") + "core";

  privacyUrl = PROD
    ? "https://inkfree.app/privacy-policy/"
    : "https://uat.inkfree.app/privacy-policy/";

  tNcUrl = PROD
    ? "https://inkfree.app/terms/"
    : "https://uat.inkfree.app/terms/";

  pricingUrl = PROD
    ? "https://inkfree.app/pricing/"
    : "https://uat.inkfree.app/pricing/";

  // Mailzzy signup popup behind the promo teaser's "Notify me". Mailzzy only
  // has production forms, so a signup from UAT or dev joins the live list.
  PROMO_NOTIFY_POPUP_SCRIPT =
    "https://forms.mailzzy.com/forms/prod/mailzzymarketing/popup/8725ac5084c64114be617.js";

  inkfree = "inkfree";

  // Base Folders
  public = "public";
  secure = "secure";
  multiFactor = "multiFactor";
  restricted = "restricted";
  user = "user";
  document = "document";
  contact = "contact";
  social = "social";
  groups = "group";
  group = "group";
  tag = "tag";
  search = "search";
  count = "count";

  //Permissions
  SELF = "self";
  GET = "fetch";
  ADD = "add";
  UPDATE = "update";
  UPLOAD = "upload";
  DELETE = "delete";

  doSign = "/document/sign/do";
  landingViewPath = "/";

  //NOTIFICATION
  // API Keys (Zapier / integrations) — PostAuth: any logged-in user, own keys only.
  // POST/GET on the base; DELETE appends the keyId (`kid_...`).
  API_KEYS = `${this.url_core}/secure/api-keys`;

  // Embedded Components. Exchange is public (the one-time token is the credential); the sign_started
  // event rides the signer's callback ?id=&key=; the editor endpoints take only the X-Embed-Session header.
  EMBED_ORIGINS = `${this.url_core}/secure/embed/origins`;
  EMBED_EXCHANGE = `${this.url_core}/public/embed/exchange`;
  EMBED_EVENT = `${this.url_core}/callback/embed/event/request`;
  EMBED_EDITOR = `${this.url_core}/embed/editor/request`;
  EMBED_EDITOR_DOCUMENT_URL = `${this.url_core}/embed/editor/document/url/request`;
  EMBED_EDITOR_DIMENSIONS = `${this.url_core}/embed/editor/document/dimensions/request`;
  EMBED_EDITOR_SEND = `${this.url_core}/embed/editor/send/request`;
  EMBED_EDITOR_DOCUMENT_LIMIT = `${this.url_core}/embed/editor/document/limit/request`;
  EMBED_EDITOR_DOCUMENT_UPLOAD = `${this.url_core}/embed/editor/document/upload/request`;
  EMBED_EDITOR_DOCUMENT_REMOVE = `${this.url_core}/embed/editor/document/remove/request`;
  EMBED_EDITOR_DRAFT = `${this.url_core}/embed/editor/draft/request`;
  EMBED_EDITOR_AI_SUMMARY = `${this.url_core}/embed/editor/ai/summary/request`;
  EMBED_EDITOR_AI_CHAT = `${this.url_core}/embed/editor/ai/chat/request`;
  EMBED_EDITOR_AI_FIELDS = `${this.url_core}/embed/editor/ai/fields/request`;
  EMBED_EDITOR_SMS_CONSENT = `${this.url_core}/embed/editor/sms/consent/request`;

  GET_NOTIFICATION = `${this.url_core}/secure/notification/web/fetch/all`;
  GET_NOTIFICATION_COUNT = `${this.url_core}/secure/notification/web/fetch`;
  DELETE_ALL_NOTIFICATION = `${this.url_core}/secure/notification/web/delete/all`;
  DELETE_NOTIFICATION = `${this.url_core}/secure/notification/web/delete`;
  MARK_AS_READ_ALL = `${this.url_core}/secure/notification/web/read/all`;
  MARK_AS_READ = `${this.url_core}/secure/notification/web/read`;

  DELETE_DOCUMENT = `${this.url}/${this.secure}/${this.document}/${this.deletePermission}`;
  DOCUMENTS = `${this.url}/${this.secure}/documents/owner`;

  // USERS
  GET_APP_USERS = `${this.url}/internal/users/limit`;
  GET_APP_USERS_COUNT = `${this.url}/internal/users/count`;
  GET_EXTERNAL_USERS = `${this.url}/external/users/limit`;
  GET_EXTERNAL_USERS_COUNT = `${this.url}/external/users/count`;
  UPDATE_PROFILE_PICTURE = `${this.url_core}/${this.secure}/${this.user}/profile/picture/${this.updatePermission}`;
  REMOVE_PROFILE_PICTURE = `${this.url_core}/${this.secure}/${this.user}/profile/picture/remove`;
  SAVE_PREFERENCES = `${this.url_core}/${this.secure}/${this.user}/preferences/update`;
  RESET_MFA = `${this.url_core}/mfa/disable/email`;
  UNLOCK_USER = `${this.url_core}/unlock/user/email`;
  MARKERING_SUBSCRIBER = `${this.url_core}/public/marketing/subscriber/${this.addPermission}`;

  //Team
  /** `POST {GET_ALL_USER_WITH_SEARCH}/limit/{limit}/page/{pageNo}` — every status. */
  GET_ALL_USER_WITH_SEARCH = `${this.url_core}/users/search`;
  GET_ALL_USER_WITH_SEARCH_COUNT = `${this.url_core}/users/search/count`;
  /** `POST {SECURE_USER_SEARCH}/limit/{limit}/page/{pageNo}`, raw text body — any signed-in user, own account. */
  SECURE_USER_SEARCH = `${this.url_core}/secure/user/search`;
  ADD_USER = `${this.url_core}/secure/user/add`;
  UPDATE_USER = `${this.url_core}/secure/user/update`;

  // Workspaces (Inkfree workspace admin) — append /{id} where noted
  WORKSPACE_FETCH = `${this.url_core}/secure/workspace/fetch`;
  WORKSPACE_MINE = `${this.url_core}/secure/workspace/mine`;
  WORKSPACE_MY_PERMISSIONS = `${this.url_core}/secure/workspace/permissions/mine`;
  WORKSPACE_ADD = `${this.url_core}/secure/workspace/add`;
  WORKSPACE_UPDATE = `${this.url_core}/secure/workspace/update`; // + /{id}
  WORKSPACE_ARCHIVE = `${this.url_core}/secure/workspace/archive`; // + /{id}
  WORKSPACE_UNARCHIVE = `${this.url_core}/secure/workspace/unarchive`; // + /{id}
  WORKSPACE_MOVE = `${this.url_core}/secure/workspace/move`; // + /{id}, body { parentId }
  WORKSPACE_ENROLLMENT_SEARCH = `${this.url_core}/secure/workspace/enrollment/search`; // ?q=
  WORKSPACE_BASE = `${this.url_core}/secure/workspace`; // + /{id}/member/(fetch|add), /{id}/quota
  WORKSPACE_QUOTA_FETCH = `${this.url_core}/secure/workspace/quota/fetch`;
  WORKSPACE_ROLE_FETCH = `${this.url_core}/secure/workspace/role/fetch`;
  WORKSPACE_ROLE_ADD = `${this.url_core}/secure/workspace/role/add`;
  WORKSPACE_ROLE_UPDATE = `${this.url_core}/secure/workspace/role/update`; // + /{id}
  WORKSPACE_ROLE_DELETE = `${this.url_core}/secure/workspace/role/delete`; // + /{id}?reassignTo=
  WORKSPACE_MEMBER_DELETE = `${this.url_core}/secure/workspace/member/delete`; // + /{membershipId}
  WORKSPACE_MEMBERSHIP = `${this.url_core}/secure/workspace/membership`; // + /{membershipId}/role/{roleId}
  RESTART_MFA_FOR_SINGLE_USER = `${this.url_core}/mfa/disable`;

  //Account
  UPDATE_ACCOUNT = `${this.url_core}/user/account/details/update`;
  GET_ACCOUNT_DETAILS = `${this.url_core}/secure/accounts`;

  //SESSION
  GET_USER_SESSIONS = `${this.url_core}/${this.secure}/${this.user}/session/list`;
  INACTIVATE_SESSION = `${this.url_core}/${this.secure}/${this.user}/inactivate/session`;

  // ROLES MANAGEMENT
  GET_RESOURCES_BY_DOMAIN = `${this.url_core}/${this.secure}/${this.user}/resources`;
  GET_USER_PROFILE = `${this.url_core}/${this.secure}/${this.user}/email`;
  GET_ROLES_BY_DOMAIN = `${this.url_core}/roles`;
  GET_ROLES_BY_DOMAIN_COUNT = `${this.url_core}/roles/count`;
  GET_ROLES_SEARCH = `${this.url_core}/roles/search`;
  GET_ROLES_SEARCH_COUNT = `${this.url_core}/roles/count/search`;
  ADD_ROLE = `${this.url_core}/role/${this.addPermission}`;
  UPDATE_ROLE = `${this.url_core}/role/${this.updatePermission}`;
  GET_ROLES = `${this.url_core}/secure/user/roles`;
  GET_ALL_ROLES_WITH_SEARCH = `${this.url_core}/role/fetch`;
  GET_ALL_ROLES_WITH_SEARCH_COUNT = `${this.url_core}/role/fetch/count`;
  GET_ROLES_COUNT = `${this.url_core}/roles/count`;

  // SECURITY
  GET_QR_CODE = `${this.url_core}/${this.secure}/multiFactor/${this.fetchPermission}/qrCode`;
  GET_SECRET_KEY = `${this.url_core}/${this.secure}/multiFactor/${this.fetchPermission}/secretKey`;
  VERIFY_MFA = `${this.url_core}/${this.secure}/${this.updatePermission}/mfa`;
  VERIFY_TOTP = `${this.url_core}/${this.public}/totp/verify`;

  //ADD LOCATION
  ADD_LOCATION = `${this.url}/location/${this.addPermission}`;

  // inkfree
  PUBLIC_URI_PATH_TOKEN = `${this.url_core}/public`;
  SECURE_URI_PATH_TOKEN = `${this.url_core}/secure`;
  RESTRICTED_URI_PATH_TOKEN = `${this.url_core}/restricted`;
  WORKFLOW_PATH = `${this.url_core}/secure`;
  MULTIFACTOR = "multiFactor";
  BILLING_URL = `${this.url_core}/billing`;

  // Auth
  LOGIN = `${this.url_core}/${this.public}/${this.user}/login`;
  // MCP OAuth bridge (Inkfree Authorization Server on ss-core-service-mcp).
  // MCP_AUTH_BRIDGE trades the authToken from LOGIN for a server-side
  // session cookie and 302s onward; MCP_OAUTH_AUTHORIZE is the consent
  // approval endpoint. Both must be hit via a real form POST, never fetch —
  // see screens/Auth/Mcp/McpService.ts.
  MCP_AUTH_BRIDGE = `${this.url_core}/mcp/auth-bridge`;
  // AWS Marketplace setup (screens/Auth/AwsMarketplace): core redirects a buyer here after resolving their
  // registration token; CLAIM is checked before sign-in, LINK binds the purchase to the signed-in account.
  AWS_MARKETPLACE_CLAIM = `${this.url_core}/public/billing/aws-marketplace/claim`;
  AWS_MARKETPLACE_LINK = `${this.url_core}/secure/billing/aws-marketplace/link`;
  // Where a buyer reopens "Set up your account" to get a fresh registration token.
  AWS_MARKETPLACE_SUBSCRIPTIONS = "https://console.aws.amazon.com/marketplace/home#/subscriptions";
  MCP_OAUTH_AUTHORIZE = `${this.url_core}/oauth2/authorize`;
  GET_MCP_CONSENT_CLIENT_INFO = `${this.url_core}/mcp/consent/client-info`;
  REFRESHTOKEN = `${this.url_core}/${this.public}/refresh/token`;
  RESET_PASSWORD = `${this.url_core}/${this.public}/${this.user}/pwd/reset`;
  UPDATE_PASSWORD = `${this.url_core}/${this.restricted}/${this.user}/pwd/${this.updatePermission}`;
  VERIFY_TEMP_PASSWORD = `${this.url_core}/${this.public}/${this.user}/pwd/verify`;
  MFA_GET_QR_CODE = `${this.url_core}/${this.restricted}/${this.multiFactor}/${this.fetchPermission}/qrCode`;
  MFA_GET_PREAUTH_KEY = `${this.RESTRICTED_URI_PATH_TOKEN}/${this.MULTIFACTOR}/${this.GET}/secretKey`;
  ACTIVATE_MFA = `${this.url_core}/${this.restricted}/${this.multiFactor}/enable/mfa`;
  SAVE_FIREBASE_TOKEN = `${this.url}/${this.secure}/${this.user}/save/deviceId`;
  REMOVE_DEVICE_ID = `${this.url}/${this.secure}/${this.user}/remove/deviceId`;
  REGISTER_USER = `${this.url_core}/${this.public}/register`;
  RESEND_ACCOUNT_VERIFICATION_EMAIL = `${this.url_core}/${this.public}/resend/account/verification/email`;
  OAUTH_LOGIN = `${this.url_core}/${this.public}/oauth/user/login`;
  OAUTH_SIGN_UP = `${this.url_core}/${this.public}/oauth/user/register`;

  //sign up
  REGISTER_NEW_USER = `${this.url_core}/public/register`;
  ACTIVATE_NEW_USER = `${this.url_core}/secure/user/activate`;

  //Billing-Usage Page API
  getPaymentMethods = `${this.BILLING_URL}/${this.fetchPermission}/paymentMethod`;
  getCardDetail = `${this.BILLING_URL}/${this.fetchPermission}/paymentMethod`;
  deleteCard = `${this.BILLING_URL}/${this.deletePermission}/paymentMethod`;
  addCard = `${this.BILLING_URL}/${this.addPermission}/paymentMethod`;
  UPDATE_CARD = `${this.BILLING_URL}/${this.updatePermission}/paymentMethod`;
  ADD_PAID_CUSTOMER = `${this.BILLING_URL}/${this.addPermission}/paidCustomer`;
  UPDATE_PLAN = `${this.BILLING_URL}/${this.updatePermission}/plan`;
  CANCEL_PLAN = `${this.BILLING_URL}/${this.deletePermission}/subscription`;
  PLAN_STATUS = `${this.BILLING_URL}/${this.fetchPermission}/subscription/status`;
  GET_CURRENT_PLAN = `${this.PUBLIC_URI_PATH_TOKEN}/plan/account`;
  GET_INVOICE_PAGE = `${this.BILLING_URL}/${this.fetchPermission}/invoice/page`;
  GET_BILL_COUNT = `${this.BILLING_URL}/${this.fetchPermission}/count`;
  viewPlans = `${this.PUBLIC_URI_PATH_TOKEN}/plans/inkfree/account`;
  newPlans = `${this.PUBLIC_URI_PATH_TOKEN}/plans/inkfree/customised`;
  customPlan = `${this.SECURE_URI_PATH_TOKEN}/custom/plans`;
  GET_ALL_PLANS = `${this.PUBLIC_URI_PATH_TOKEN}/plans`;
  VERIFY_COUPON = `${this.PUBLIC_URI_PATH_TOKEN}/verify/couponCode`;

  // ---- SMS credits ----
  /**
   * Prepaid SMS wallet, sold by quantity as a one-time add-on. Reads use the
   * same `fetch` permission segment as the rest of billing (the spec writes
   * these as `billing/get/...`, which the service does not serve); the buy
   * call keeps `add`.
   *
   * `SMS_CREDIT` returns the balance plus the offer (price, min/max); the offer
   * is absent when credits aren't on sale in the account's currency.
   * `{SMS_CREDIT_QUOTE}/{quantity}` prices a quantity the same way the charge
   * is computed — by tier, so the rate depends on the quantity.
   *
   * `{SMS_CREDIT_ACTIVITY}/{page}/limit/{limit}` is the **customer-facing**
   * feed: credits bought and credits spent in one list, with sends grouped one
   * line per document per kind per day. Paged like the invoice list — `page`
   * counts from **1** and the server computes the offset, so never send one
   * (the old `?limit=&offset=` form is gone, not deprecated: it 404s).
   * `limit` is capped at 100 server-side and falls back to 25 if it isn't a
   * number; `limit/ALL` (or page 0) returns the whole feed unpaged. Both
   * halves are over-read to page, so large pages cost more than they look.
   * There is no total-count field, so "page N of M" is not derivable.
   * (A raw money ledger also exists at `…/smsCredit/history` — purchases and
   * hand adjustments only, with a running `balanceAfter`. That one is for a
   * finance/reconciliation view, which this app doesn't have, so it is
   * deliberately not bound here.)
   */
  SMS_CREDIT = `${this.BILLING_URL}/${this.fetchPermission}/smsCredit`;
  /**
   * The pack catalogue on its own — read live from the plan table on every
   * call, so a repriced pack takes effect without a deploy. Used to re-read
   * prices after a `409` says they moved mid-purchase.
   */
  SMS_CREDIT_PACKS = `${this.BILLING_URL}/${this.fetchPermission}/smsCredit/packs`;
  SMS_CREDIT_QUOTE = `${this.BILLING_URL}/${this.fetchPermission}/smsCredit/quote`;
  SMS_CREDIT_ACTIVITY = `${this.BILLING_URL}/${this.fetchPermission}/smsCredit/activity/page`;
  /**
   * Buy credits. Body carries `quantity` and a `requestId` UUID used as
   * Stripe's idempotency key, so a retry returns the same invoice instead of
   * charging twice. Not the recurring add-on path — that one rejects this plan.
   */
  SMS_CREDIT_BUY = `${this.BILLING_URL}/${this.addPermission}/smsCredit`;

  // ---- Per-seat billing ----
  /**
   * Cost of changing to a given seat count; preview only, nothing is charged.
   * `{count}` is the target *total* seat count, not a delta:
   * `GET {SEAT_PREVIEW}/{count}`. Works for both an increase and a decrease.
   */
  SEAT_PREVIEW = `${this.BILLING_URL}/${this.fetchPermission}/seat/preview`;
  /** Buy or release seats: `POST {MANAGE_SEATS}/{count}`. */
  MANAGE_SEATS = `${this.BILLING_URL}/${this.updatePermission}/seats`;
  /**
   * Base for the per-plan billing lookups: `{SEAT_CHECK}/{planId}/seat/check`
   * (whether switching needs a seat reduction first) and
   * `{SEAT_CHECK}/{planId}/switch/preview` (exact cost of the switch).
   */
  SEAT_CHECK = `${this.BILLING_URL}/${this.fetchPermission}/plan`;
  /** Current subscription (account + plan). */
  FETCH_SUBSCRIPTION = `${this.BILLING_URL}/${this.fetchPermission}/subscription`;
  /** Gross cost, saved account credit and the net due next renewal. */
  BILLING_SUMMARY = `${this.BILLING_URL}/${this.fetchPermission}/summary`;
  /**
   * ACTIVE / CANCELLED / NEVER_SUBSCRIBED, plus the plan currently in effect.
   * Safe to call on any screen — unlike the rest of the billing endpoints it
   * never errors for an unsubscribed account.
   */
  SUBSCRIPTION_STATE = `${this.BILLING_URL}/${this.fetchPermission}/subscription/state`;
  /** App-level billing flags — the first of the two per-seat gates. */
  BILLING_CONFIG = `${this.BILLING_URL}/${this.fetchPermission}/config`;
  /** Activate / deactivate a user — releases or re-consumes a seat. */
  UPDATE_USER_STATUS = `${this.url_core}/update/user/id`;
  /** Permanently remove a user (also frees the seat). */
  DELETE_USER = `${this.url_core}/secure/user/delete`;
  GET_SECURE_USERS = `${this.url_core}/secure/users`;
  GET_SECURE_USERS_COUNT = `${this.url_core}/secure/users/count`;

  // GET_ROLES = `${this.url_core}/roles`;
  // GET_USERS_ROLES = `${this.SECURE_URI_PATH_TOKEN}/user/roles`;
  GET_RESOURCES = `${this.SECURE_URI_PATH_TOKEN}/user/resources`;

  //contacts
  GET_CONTACTS_EXCLUDE = `${this.url_core}/contact/fetch/exclude/search`;
  GET_CONTACTS = `${this.url_core}/contact/fetch`;
  GET_CONTACTS_COUNT = `${this.url_core}/contact/fetch/count`;
  ADD_CONTACTS = `${this.url_core}/contact/add/addressbook`;
  UPDATE_CONTACTS = `${this.url_core}/contact/update/addressbook`;
  UPLOAD_CONTACTS_CSV = `${this.url_core}/contact/add/by/csv`;
  UPLOAD_BULK_CONTACT_CSV = `${this.url_core}/sign/add/signer/by/csv`;

  // Renewable Documents
  GET_RENEWABLE_DOCS_COUNT = `${this.url_core}/sign/fetch/renewable/documents/counts/months`;
  GET_RENEWABLE_DOCUMENTS_BY_DATE = `${this.url_core}/sign/fetch/renewable/documents`;
  DOWNLOAD_SIGNED_PDF = `${this.url_core}/sign/download/signed/pdf/envelopeId`;

  // Reports
  GET_REPORT_ENVELOPES = `${this.url_core}/sign/fetch/request/audit/metrics`;
  GET_REPORT_COUNTS_METRICS = `${this.url_core}/sign/fetch/request/counts/metrics`;
  GET_REPORT_USER_REQUESTS_PAGE = `${this.url_core}/sign/fetch/user/report/page`;
  GET_REPORT_USER_REQUESTS_COUNT = `${this.url_core}/sign/fetch/user/report/count`;
  GET_TEMPLATE_EFFICIENCY_PAGE = `${this.url_core}/sign/fetch/report/template/efficiency/pageNo`;
  GET_TEMPLATE_EFFICIENCY_COUNT = `${this.url_core}/sign/fetch/report/template/efficiency/count`;
  GET_REPORT_RECIPIENTS_PAGE = `${this.url_core}/sign/fetch/report/recipients/pageNo`;
  GET_REPORT_RECIPIENTS_COUNT = `${this.url_core}/sign/fetch/report/recipients/count`;
  GET_REPORT_REQUEST_STATUS_COUNTS = `${this.url_core}/sign/fetch/request/count/status`;

  // Sign Requests
  SENT_REQUESTS = `${this.url_core}/sign/fetch/requests`;
  INBOX_REQUESTS = `${this.url_core}/sign/fetch/inbox/requests`;

  // Sharing + custody transfer
  SHARE_REQUEST = `${this.url_core}/sign/add/share/request`;
  SHARES_FOR_REQUEST = `${this.url_core}/sign/fetch/share/request`;
  REVOKE_SHARE = `${this.url_core}/sign/update/revoke/share`;
  SHARED_REQUESTS = `${this.url_core}/sign/fetch/shared/requests/status`;
  TRANSFER_OWNERSHIP = `${this.url_core}/sign/update/transfer/ownership`;

  // Tickets
  VIEW_FILE = `${this.WORKFLOW_PATH}/document/view`;
  DOWNLOAD_FILE = `${this.WORKFLOW_PATH}/document/download`;
  FETCH_TICKETS_METRICS = `${this.WORKFLOW_PATH}/tickets/my/metrics`;
  TICKETS_BY_STATUS = `${this.WORKFLOW_PATH}/tickets/my/status`;
  TICKET_BY_ID = `${this.WORKFLOW_PATH}/workflow/task`;
  UPLOAD_TICKET_FILE = `${this.WORKFLOW_PATH}/ticket/document/upload/ticketId`;
  ADD_TICKET_COMMENT = `${this.WORKFLOW_PATH}/task/comment/add`;
  processDefinitions = `${this.SECURE_URI_PATH_TOKEN}/workflow/process/def`;
  addSuportTicket = `${this.SECURE_URI_PATH_TOKEN}/ticket/add`;

  //passkey
  PASSKEY_REGISTER = `${this.SECURE_URI_PATH_TOKEN}/webauthn/register/start`;
  PASSKEY_FINISH_REGISTER = `${this.SECURE_URI_PATH_TOKEN}/webauthn/register/finish`;
  PASSKEY_LOGIN = `${this.PUBLIC_URI_PATH_TOKEN}/webauthn/start`;
  PASSKEY_FINISH_LOGIN = `${this.PUBLIC_URI_PATH_TOKEN}/webauthn/finish`;
  GET_ALL_PASSKEY = `${this.SECURE_URI_PATH_TOKEN}/webauthn/passkeys`;
  DELETE_PASSKEY = `${this.SECURE_URI_PATH_TOKEN}/webauthn/delete/passkey`;
  UPDATE_PASSKEY = `${this.SECURE_URI_PATH_TOKEN}/webauthn/update/passkey`;

  // ---------------------------------

  //Sign Requests
  FETCH_DIMENSIONS = `${this.url_core}/${this.secure}/sign/fetch/document/dimensions/fromRequest`;
  FETCH_DIMENSIONS_CALLBACK = `${this.url_core}/callback/fetch/document/dimensions/requestToken`;
  FETCH_SIGN_REQUESTS = `${this.url_core}/sign/fetch/requests/status`;
  FETCH_AUDITS = `${this.url_core}/sign/fetch/document/request/logs/requestId`;
  VERIFY_AUDIT = `${this.url_core}/sign/fetch/document/request/logs/verify/requestId`;
  GET_VIEW_SIGN_REQUEST = `${this.url_core}/sign/fetch/request`;
  GET_CALLBACK_KEY_FOR_SIGN_NOW = `${this.url_core}/${this.secure}/sign/fetch/callback/key`;
  DOWNLOAD_DOCS_AS_ZIP_CALLBACK = `${this.url_core}/callback/sign/download/zip/pdf/request`;
  DOWNLOAD_SIGN_AS_ZIP = `${this.url_core}/sign/pdf/download/zip`;
  MERGED_SIGNED_PDF = `${this.url_core}/callback/sign/download/pdf/final/signed/image/false/request`;
  DECRYPT_SIGN_TOKEN = `${this.url_core}/callback/fetch/role/request`;
  DOWNLOAD_DOCS_AS_ZIP = `${this.url_core}/sign/pdf/download/zip`;
  VOID_SIGN_REQ = `${this.url_core}/sign/update/void/request`;
  RESEND_SIGN_REQ = `${this.url_core}/sign/send/resend/request`;
  GET_ENVELOPE_ID = `${this.url_core}/secure/sign/fetch/envelope/id`;
  COPY_TEMPLATE_FILES = `${this.url_core}/sign/send/copy/files`;
  UPLOAD_UNSIGNED_PDF = `${this.url_core}/secure/upload/pdf`;
  DETECT_FIELDS = `${this.url_core}/sign/send/document/field-detect`;
  PRESEND_REVIEW = `${this.url_core}/sign/send/presend/review/envelopeId`;
  APP_PLAN_LIMIT_BY_ENTITY = `${this.url_core}/secure/appPlanLimit/entity`;
  UNSIGNED_DOC_DIMENSIONS = `${this.url_core}/sign/fetch/document/dimensions/fromRequest`;
  TEMPLATE_UNSIGNED_DOC_DIMENSIONS = `${this.url_core}/template/fetch/document/dimensions/fromRequest`;
  UNSIGNED_DOC_DIMENSIONS_CALLBACK = `${this.url_core}/callback/fetch/document/dimensions`;
  UNSIGEND_DOC_URL = `${this.url_core}/sign/fetch/unsigned/document/fromRequest`;
  TEMPLATE_UNSIGEND_DOC_URL = `${this.url_core}/template/fetch/unsigned/document/fromRequest`;
  UNSIGEND_DOC_URL_CALLBACK = `${this.url_core}/callback/fetch/document`;
  SEND_SIGN_REQ = `${this.url_core}/sign/send/pdf/request`;
  /**
   * **Deprecated** — the old one-shot bulk send: the whole request plus every
   * recipient in `signers[]`, fanned out server-side. Superseded by the batch
   * endpoints below and retired once nothing calls it.
   */
  BULK_SEND = `${this.url_core}/sign/send/bulk/pdf/request`;

  // ---- Bulk send batches ----
  /**
   * A batch is template-anchored: the documents, field placement, signer slots
   * and signing order all come from a template, and each row becomes one
   * envelope. Creating a batch only validates and saves a `Draft` — sending is
   * a separate call that returns `202` and drains in the background.
   *
   * **The permission word in each path is load-bearing.** Authorisation
   * substring-matches the URI against the caller's permission tokens, so
   * `fetch`/`add`/`send`/`update`/`delete` must stay where they are; a tidier
   * `/sign/bulk/batch` 403s for every non-admin user.
   *
   * The document endpoint takes no trailing segment. Add `?copyFiles=false`
   * only when the files already live in the template folder; a fresh upload
   * leaves it off so the server takes its own copy.
   */
  BULK_TEMPLATE_FROM_DOCUMENT = `${this.url_core}/sign/add/bulk/template/from-document`;
  /**
   * `{BULK_TEMPLATE_CSV}/{templateId}/csv?fixedSigners=2,3` — header row only.
   * `{BULK_TEMPLATE_CSV}/{templateId}/slots` returns the same `signerSlots`
   * shape both entry paths use, including the exact role label the CSV will
   * carry and each slot's prefillable field labels. Server-resolved on
   * purpose — don't re-derive `needsPhone` or the label from the template.
   */
  BULK_TEMPLATE_CSV = `${this.url_core}/sign/fetch/bulk/template`;
  BULK_BATCH_CREATE = `${this.url_core}/sign/add/bulk/batch`;
  BULK_BATCH_CREATE_CSV = `${this.url_core}/sign/add/bulk/batch/csv`;
  /** `{BULK_BATCH_FROM_LIST}/{listId}` */
  BULK_BATCH_FROM_LIST = `${this.url_core}/sign/add/bulk/batch/from-list`;
  /** `{BULK_BATCH_SEND}/{batchId}`, and `/{batchId}/retry` for failed rows. */
  BULK_BATCH_SEND = `${this.url_core}/sign/send/bulk/batch`;
  /**
   * `{BULK_BATCH}/{batchId}` for the batch and its derived `statusCounts`,
   * plus `/{batchId}/rows/pageNo/{n}?status=Failed`, `/rows/count`,
   * `/export` (CSV) and `/signing-queue`.
   */
  BULK_BATCH = `${this.url_core}/sign/fetch/bulk/batch`;
  BULK_BATCHES = `${this.url_core}/sign/fetch/bulk/batches/pageNo`;
  BULK_BATCHES_COUNT = `${this.url_core}/sign/fetch/bulk/batches/count`;
  /** `{BULK_BATCH_UPDATE}/{batchId}/cancel` stops the queue. No batch void: sent requests are voided one by one. */
  BULK_BATCH_UPDATE = `${this.url_core}/sign/update/bulk/batch`;
  BULK_LIST_ADD = `${this.url_core}/sign/add/bulk/list`;
  /** `{BULK_LIST}/{listId}` */
  BULK_LIST = `${this.url_core}/sign/fetch/bulk/list`;
  BULK_LISTS = `${this.url_core}/sign/fetch/bulk/lists/pageNo`;
  BULK_LISTS_COUNT = `${this.url_core}/sign/fetch/bulk/lists/count`;
  /** `{BULK_LIST_DELETE}/{listId}` */
  BULK_LIST_DELETE = `${this.url_core}/sign/delete/bulk/list`;
  SEND_SELF_SIGN_REQ = `${this.url_core}/sign/send/request/sign`;
  PREPARE_SELF_SIGN_REQ = `${this.url_core}/sign/send/request/sign/prepare`;
  COMPLETE_SELF_SIGN_REQ = `${this.url_core}/sign/send/request/sign/complete`;
  UPLOAD_SELF_SIGN_ATTACHMENT = `${this.url_core}/sign/send/attachment/upload/request`;
  UPDATE_SIGN_REQ = `${this.url_core}/sign/update/request`;
  APPROVE_REJECT_SIGN_REQUEST = `${this.url_core}/callback`;
  SIGN_PDF = `${this.url_core}/callback/sign/pdf/request`;
  DECLINE_REQUEST = `${this.url_core}/callback/decline/pdf/request`;
  DELEGATE_REQUEST = `${this.url_core}/callback/delegate/sign/request`;
  SAVE_FIELD_DATA = `${this.url_core}/callback/save/data/request`;
  UPLOAD_SIGN_IMG = `${this.url_core}/callback/sign/upload/signature/image/request`;
  UPLOAD_SELF_SIGN_SIGN_IMG = `${this.url_core}/sign/send/upload/signature/image`;
  UPLOAD_INITIALS_IMG = `${this.url_core}/callback/sign/upload/initials/image/request`;
  UPLOAD_SELF_SIGN_INITIALS_IMG = `${this.url_core}/sign/send/upload/initials/image`;
  FETCH_DOCUMENT_SUMMARY_CALLBACK = `${this.url_core}/callback/fetch/document/summary/requestToken`;
  FETCH_DOCUMENT_SUMMARY = `${this.url_core}/sign/fetch/document/summary/envelopeId`;
  // Post-sign: the same two surfaces asked against the SIGNED copy of a completed request.
  FETCH_SIGNED_DOCUMENT_SUMMARY = `${this.url_core}/sign/fetch/signed/document/summary/envelopeId`;
  SIGN_REQ_LIST_COUNT = `${this.url_core}/sign/fetch/requests/count`;
  SAVE_DRAFT_SIGN_REQ = `${this.url_core}/sign/send/request/as/draft`;
  DELETE_DRAFT_SIGN_REQ = `${this.url_core}/sign/delete/draft`;
  UPLOAD_DOCUMENTS_LIMIT = `${this.url_core}/secure/document/upload/limit`;
  FETCH_REQUEST_DATA = `${this.url_core}/sign/fetch/requests/counts`;
  ASK_PDF = `${this.url_core}/sign/fetch/chat/with/pdf`;
  ASK_SIGNED_PDF = `${this.url_core}/sign/fetch/chat/with/signed/pdf`;
  ASK_PDF_CALLBACK = `${this.url_core}/callback/fetch/chat/with/pdf`;
  FETCH_HIGHLIGHTED_DOCUMENTS = `${this.url_core}/sign/fetch/highlighted/document/envelopeId`;

  // Signer attachments.
  // Signer-side calls sit on the `callback` lane: the signer is an unauthenticated guest identified by
  // the request token plus the `key` query param, exactly like UPLOAD_SIGN_IMG above. Sender-side calls
  // sit on `sign/fetch/...` — note the backend's UrlTokens.GET is the literal string "fetch", not "get".
  UPLOAD_SIGNER_ATTACHMENT = `${this.url_core}/callback/sign/attachment/upload/request`;
  FETCH_SIGNER_ATTACHMENTS = `${this.url_core}/callback/sign/attachments/request`;
  SIGNER_ATTACHMENT = `${this.url_core}/callback/sign/attachment`;
  FETCH_REQUEST_ATTACHMENTS = `${this.url_core}/sign/fetch/attachments/request`;
  DOWNLOAD_REQUEST_ATTACHMENT = `${this.url_core}/sign/fetch/attachment`;
  DOWNLOAD_ALL_REQUEST_ATTACHMENTS = `${this.url_core}/sign/fetch/attachments/download/request`;

  // Intelligent Contract Repository. Core proxies these to the AI service (it holds the service token and
  // mints a per-call identity pair, X-Core-Id / X-Core-Key, for the logged-in user); the browser never talks
  // to the AI directly. Search is always across every document the user owns -- there is no per-document variant.
  CONTRACT_DOCUMENTS = `${this.url_core}/sign/fetch/contracts/documents`;
  CONTRACT_SEARCH = `${this.url_core}/sign/fetch/contracts/search`;
  // Compare two versions of a contract (multipart: `revised` + `original` or `originalDocumentId`).
  CONTRACT_COMPARE = `${this.url_core}/sign/fetch/contracts/compare`;
  // Progress of one AI ingest batch: one connection, pushed updates until every document is embedded.
  // Core also exposes a one-shot `contracts/status`, which nothing in the app asks for.
  CONTRACT_BATCH_STATUS_STREAM = `${this.url_core}/sign/fetch/contracts/status/stream`;

  // Custom fields: the values signers submitted (JSON for the view screen, CSV export).
  FETCH_REQUEST_FIELD_DATA = `${this.url_core}/sign/fetch/field-data/request`;
  DOWNLOAD_REQUEST_FIELD_DATA = `${this.url_core}/sign/download/field-data/request`;

  // Custom field library: reusable field definitions shown under "Custom Fields" in the editor.
  FETCH_CUSTOM_FIELDS = `${this.url_core}/sign/fetch/custom-fields`;
  ADD_CUSTOM_FIELD = `${this.url_core}/sign/add/custom-field`;
  UPDATE_CUSTOM_FIELD = `${this.url_core}/sign/update/custom-field`;
  DELETE_CUSTOM_FIELD = `${this.url_core}/sign/update/custom-field`;

  // In-person signing — host session endpoints under `sign/send/` so any sender
  // with the "send" permission is authorized (not only account owners).
  IN_PERSON_SESSION_START = `${this.url_core}/sign/send/in-person/session/start`;
  IN_PERSON_SESSION_NEXT = `${this.url_core}/sign/send/in-person/session/next`;
  IN_PERSON_SESSION_RETURN = `${this.url_core}/sign/send/in-person/session/return`;
  // Read BEFORE offering a hand-off: who the host may hand the device to right
  // now, or who the envelope is waiting on. A read, so it sits under
  // `sign/fetch/` rather than `sign/send/` like the three session verbs above.
  IN_PERSON_SESSION_STATUS = `${this.url_core}/sign/fetch/in-person/session`;
  // Consent: the host's is host-auth, the signer's is token-scoped under
  // `callback/` because the walk-up signer has no session of their own.
  IN_PERSON_CONSENT_HOST = `${this.url_core}/sign/send/in-person/consent`;
  IN_PERSON_CONSENT_SIGNER = `${this.url_core}/callback/in-person/consent/request`;
  // The requester's own attestation, taken once per account the first time
  // they add an in-person signer — not tied to any one envelope.
  IN_PERSON_REQUESTER_CONSENT = `${this.url_core}/sign/send/in-person/requester-consent`;
  // Attaches an email to a signer post-signing so the completed copy reaches
  // them — offered on the completion card, optional. Token-scoped: it is the
  // signer's own device asking, on their own token.
  IN_PERSON_SIGNER_EMAIL = `${this.url_core}/callback/in-person/signer/email`;
  // The public link mailed to `signRequestConfig.inPersonHostEmail` — mirrors
  // the `sign/send/in-person/*` host endpoints above, but `hostToken`-scoped
  // under `callback/` so the host can run the whole session without logging in.
  IN_PERSON_HOST_LINK = `${this.url_core}/callback/in-person/host`;
  IN_PERSON_HOST_LINK_CONSENT = `${this.url_core}/callback/in-person/host/consent`;
  IN_PERSON_HOST_LINK_SESSION_START = `${this.url_core}/callback/in-person/host/session/start`;
  IN_PERSON_HOST_LINK_SESSION_NEXT = `${this.url_core}/callback/in-person/host/session/next`;
  IN_PERSON_HOST_LINK_SESSION_RETURN = `${this.url_core}/callback/in-person/host/session/return`;

  //Templates
  GET_FOLDER_DATA = `${this.url_core}/template/fetch/page`;
  GET_FOLDER_DATA_COUNT = `${this.url_core}/template/fetch`;
  GET_ALL_FOLDERS = `${this.url_core}/template/fetch/folders`;
  CREATE_NEW_FOLDER = `${this.url_core}/template/add/new`;
  MOVE_FOLDER = `${this.url_core}/template/update/move`;
  RENAME_FOLDER = `${this.url_core}/template/update/rename`;
  DELETE_TEMPLATE = `${this.url_core}/template/delete/new`;
  DELETE_ANYWAY_TEMPLATE = `${this.url_core}/template/delete/anyway`;
  SAVE_TEMPLATE = `${this.url_core}/template/add/new`;
  UPDATE_TEMPLATE = `${this.url_core}/template/update`;
  TEMPLATE_FOLDER_SEARCH = `${this.url_core}/template/fetch/search`;
  TEMPLATE_LIBRARY = `${this.url_core}/public/templateLibrary/${this.inkfree}`;
  IMPORT_LIBRARY_TEMPLATE = `${this.url_core}/template/add/library`;

  //Sign Request Folders
  SIGN_FOLDER_GET_PAGE = `${this.url_core}/sign/fetch/page`;
  SIGN_FOLDER_GET_COUNT = `${this.url_core}/sign/fetch/count`;
  SIGN_FOLDER_GET_TREE = `${this.url_core}/sign/fetch/folders`;
  SIGN_FOLDER_CREATE = `${this.url_core}/sign/add/folder`;
  SIGN_FOLDER_MOVE = `${this.url_core}/sign/update/move`;
  SIGN_FOLDER_RENAME = `${this.url_core}/sign/update/rename`;
  SIGN_FOLDER_DELETE_SAFE = `${this.url_core}/sign/delete/new`;
  SIGN_FOLDER_DELETE_ANYWAY = `${this.url_core}/sign/delete/anyway`;
  SIGN_FOLDER_SEARCH = `${this.url_core}/sign/fetch/search`;

  // Sign Request filters, tags and saved views
  SIGN_FILTER_GET_PAGE = `${this.url_core}/sign/fetch/requests/filter/page`;
  SIGN_FILTER_GET_SENDERS = `${this.url_core}/sign/fetch/requests/senders`;
  SIGN_TAGS_GET = `${this.url_core}/sign/fetch/tags`;
  SIGN_TAG_CREATE = `${this.url_core}/sign/add/tag`;
  SIGN_TAG_UPDATE = `${this.url_core}/sign/update/tag`;
  SIGN_TAG_DELETE = `${this.url_core}/sign/delete/tag`;
  /** `{SIGN_REQUEST_TAGS_SET}/{requestId}/tags` replaces a request's tag set. */
  SIGN_REQUEST_TAGS_SET = `${this.url_core}/sign/add/request`;
  SIGN_VIEWS_GET = `${this.url_core}/sign/fetch/views`;
  SIGN_VIEW_CREATE = `${this.url_core}/sign/add/view`;
  SIGN_VIEW_UPDATE = `${this.url_core}/sign/update/view`;
  SIGN_VIEW_DELETE = `${this.url_core}/sign/delete/view`;
  SIGN_VIEWS_LAST_USED_GET = `${this.url_core}/sign/fetch/views/last-used`;
  SIGN_VIEWS_LAST_USED_SAVE = `${this.url_core}/sign/add/views/last-used`;

  // Unlayer
  FETCH_UNLAYER_SCAFFOLD = `${this.url_core}/template/fetch/unlayer/scaffold`;
  CREATE_WEBFORM = `${this.url_core}/template/add/webforms`;
  GET_WEBFORM = `${this.url_core}/template/fetch/webforms`;
  GET_WEBFORMS_BY_TEMPLATE = `${this.url_core}/template/fetch/webforms/byTemplate`;
  UPDATE_WEBFORM = `${this.url_core}/template/update/webforms`;
  DELETE_WEBFORM = `${this.url_core}/template/delete/webforms`;
  // Build with AI: the AI webform designer, through core. The permission token
  // is what core's role check reads (add starts, fetch reads, update changes).
  AI_WEBFORM_ADD = `${this.url_core}/template/add/webforms/ai`;
  AI_WEBFORM_FETCH = `${this.url_core}/template/fetch/webforms/ai`;
  AI_WEBFORM_UPDATE = `${this.url_core}/template/update/webforms/ai`;
  WEBFORMS_VIEW_CALLBACK = `${this.url_core}/callback/webforms/view`;
  WEBFORMS_SUBMIT_CALLBACK = `${this.url_core}/callback/webforms/submit`;
  SAVE_UNLAYER_HTML = `${this.url_core}/template/save/unlayer/html`;

  // Configurations
  UPDATE_AUTO_EMAIL_REMINDER_CONFIGURATION = `${this.url_core}/secure/update/account/config/auto/reminder`;
  GET_AUTO_EMAIL_REMINDER_CONFIGURATION = `${this.url_core}/secure/fetch/account/config/is/auto/reminder/on`;
  UPDATE_AUTO_REMINDER_CONFIGURATION = `${this.url_core}/secure/update/account/config/reminders`;
  GET_AUTO_REMINDER_CONFIGURATION = `${this.url_core}/secure/fetch/account/config/reminders`;
  GET_AUTO_DELEGATE_CONFIGURATION = `${this.url_core}/sign/fetch/signer`;
  UPDATE_EXPIRATION_DAYS_CONFIGURATION = `${this.url_core}/secure/update/account/config/expirationDays`;
  UPDATE_AUTO_DELEGATION_CONFIGURATION = `${this.url_core}/sign/update/signer`;
  GET_EXPIRATION_DAYS_CONFIGURATION = `${this.url_core}/secure/fetch/account/config/expirationDays`;
  GET_ATTACHMENT_CONFIGURATION = `${this.url_core}/secure/fetch/account/config/signer-attachments`;
  UPDATE_ATTACHMENT_CONFIGURATION = `${this.url_core}/secure/update/account/config/signer-attachments`;
  UPDATE_EXPIRY_PASSWORD = `${this.url_core}/secure/update/account/config/password/expiry`;
  GET_EXPIRY_PASSWORD = `${this.url_core}/secure/fetch/account/config/password/expiry`;
  GET_DEFAULT_DATE_FORMAT_CONFIGURATION = `${this.url_core}/secure/fetch/account/config/defaultDateFormat`;
  UPDATE_DEFAULT_DATE_FORMAT_CONFIGURATION = `${this.url_core}/secure/update/account/config/defaultDateFormat`;
  EXPIRY_UPDATE_PASSWORD = `${this.url_core}/restricted/user/pwd/update`;
  NOT_EXPIRY_UPDATE_PASSWORD = `${this.url_core}/secure/user/pwd/update`;
  FETCH_CERTIFICATE_TYPE_CONFIG = `${this.url_core}/callback/fetch/attach/single/certificate`;
  GET_ACCOUNT_CONFIG = `${this.url_core}/secure/fetch/account/config`;
  GET_BRANDING_SETTINGS = `${this.url_core}/secure/branding`;
  UPDATE_BRANDING_SETTINGS = `${this.url_core}/secure/branding`;
  UPLOAD_BRANDING_LOGO = `${this.url_core}/secure/branding/logo`;

  //plans
  FETCH_PLAN_LIMIT = `${this.url_core}/secure/appPlanLimit/entity`;
  FETCH_CARDS = `${this.url_core}/billing/fetch/paymentMethod`;
  ADD_CARD = `${this.url}/${this.url_core}/billing/add/paymentMethod`;
  DELETE_CARD = `${this.url_core}/billing/delete/paymentMethod`;
  FETCH_PLAN_STATUS = `${this.url_core}/billing/fetch/subscription/status`;
  FETCH_ACCOUNT_DETAILS = `${this.url_core}/secure/billing/fetch/planLimit`;
  FETCH_CURRENT_PLAN = `${this.url_core}/public/plan/account`;
  ACCESS_FEATURES = `${this.url_core}/secure/account/access`;

  //signer screen
  FETCH_SIGN_REQ = `${this.url_core}/callback/sign/fetch/request/token`;
  SIGNED_DOC_DIMENSIONS = `${this.url_core}/callback/sign/fetch/pdf/dimension/true`;
  DOWNLOAD_SIGN_PDF = `${this.url_core}/callback/sign/download/pdf/request`;
  FETCH_SIGN_IMG = `${this.url_core}/callback/sign/fetch/signature/image`;
  SELF_SIGN_FETCH_SIGN_IMG = `${this.url_core}/sign/fetch/signature/image`;
  SELF_SIGN_FETCH_INITIALS_IMG = `${this.url_core}/sign/fetch/initials/image`;
  FETCH_INITIALS_IMG = `${this.url_core}/callback/sign/fetch/initials/image`;
  SEND_OTP = `${this.url_core}/callback/generate/otp/request`;
  VERIFY_SECURITY_CODE = `${this.url_core}/callback/verify/security/code/request`;
  VERIFY_OTP = `${this.url_core}/callback/verify/otp/request`;
  // SMS delivery — sender records recipient consent before an SMS request is
  // sent (required; SMS delivery 403s without it). Signer-side phone (SMS OTP)
  // authentication reuses the email-OTP body/response shapes.
  SMS_CONSENT = `${this.url_core}/sms/consent`;
  SEND_PHONE_OTP = `${this.url_core}/callback/generate/phone-otp/request`;
  VERIFY_PHONE_OTP = `${this.url_core}/callback/verify/phone-otp/request`;
  // Signer identity verification. Signer calls ride the `callback` lane with
  // the link's `?id=&key=` pair like every other signer call; the sender's
  // per-signer summary is `${GET_VIEW_SIGN_REQUEST}/{requestId}/${IDV_REQUEST_SUFFIX}`.
  FETCH_SIGNER_IDV = `${this.url_core}/callback/fetch/idv/request`;
  START_IDV_SESSION = `${this.url_core}/callback/generate/idv/session/request`;
  VERIFY_IDV_SESSION = `${this.url_core}/callback/verify/idv/request`;
  SUBMIT_IDV_TEST_OUTCOME = `${this.url_core}/callback/submit/idv/test/request`;
  IDV_REQUEST_SUFFIX = "identity-verification";
  /** The methods a vendor is configured for here; the sender's dropdown offers only these. */
  IDV_AVAILABLE_METHODS = `${this.url_core}/secure/fetch/idv/methods`;

  VERIFY_TEMP_PASSWORD_AND_ACTIVATE = `${this.url_core}/public/user/pwd/verify/activate`;

  // Cloud storage integrations (OneDrive, Google Drive, Dropbox, ...)
  GET_SERVICES_INTEGRATED = `${this.url_core}/secure/externalApp/services/integrated`;
  CLOUD_STORAGE_AUTH_URL = `${this.url_core}/secure/cloud/storage/fetch/authUrl`;
  CLOUD_STORAGE_ACCESS_TOKEN = `${this.url_core}/secure/cloud/storage/fetch/accessToken/service`;
  CLOUD_STORAGE_FILES = `${this.url_core}/secure/cloud/storage/fetch/files/service`;
  CLOUD_STORAGE_SEARCH_FILE = `${this.url_core}/secure/cloud/storage/search/file/service`;
  CLOUD_STORAGE_UPLOAD_FILE = `${this.url_core}/secure/upload/from/cloud/storage`;

  INITIATE_ACCOUNT_CLOSURE = `${this.url_core}/${this.secure}/account/closure/initiate`;

  // WhitelistIPs (IP Allowlist) — account & app come from the JWT, never the URL/body
  IP_ALLOWLIST_FETCH = `${this.url_core}/ipAllowlist/fetch`;
  IP_ALLOWLIST_ADD = `${this.url_core}/ipAllowlist/add/entries`;
  IP_ALLOWLIST_UPDATE = `${this.url_core}/ipAllowlist/update/entries`;
  IP_ALLOWLIST_DELETE = `${this.url_core}/ipAllowlist/delete/entries`;
  IP_ALLOWLIST_UPDATE_ENABLED = `${this.url_core}/ipAllowlist/update/enabled`;
  IP_ALLOWLIST_AUDIT = `${this.url_core}/ipAllowlist/fetch/audit`;

  SAML_CONFIG = `${this.url_core}/secure/sso/config`;
  IDENTITY_ATTRIBUTE_DEFAULTS = `${this.url_core}/secure/identity/attribute-defaults`;
  SAML_LOGIN_CHECK = `${this.url_core}/public/sso/check`;
  SAML_LOGIN_INIT = `${this.url_core}/public/sso/login`;
  SAML_TOKEN_EXCHANGE = `${this.url_core}/public/sso/token`;
  SAML_SP_ACS = `${this.url_core}/login/saml2/sso`;
  SAML_SP_METADATA = `${this.url_core}/saml2/service-provider-metadata`;
  SAML_SP_SLO = `${this.url_core}/logout/saml2/slo`;
  SAML_LOGOUT = `${this.url_core}/secure/sso/logout`;
  OIDC_REDIRECT_URI_BASE = `${this.url_core}/login/oauth2/code`;
  OIDC_POST_LOGOUT_REDIRECT_URI = `${this.url_core}/sso/logout/callback`;
  OIDC_INITIATE_URI_BASE = `${this.url_core}/public/sso/oidc/initiate`;

  // Discord Webhook frontend url
  webhook_URL = PROD
    ? "https://discord.com/api/webhooks/1177478096534908929/Ykq0jiG9LfC8Fb66Ttm5uUeGiA1Hbe8dqxQ8X1EtUBJHEI3sw6HHCqhh11DmLdqYLDzb"
    : "https://discord.com/api/webhooks/1177477956260597881/4XojyhLZiDEXXxXjNPBAknXpFAXgsMtGjW0ioklEAKwJvXDFkABsatolJE6c4Fw8tvrL";
  AUTHENTICATED = `${this.url}/person/authenticated`;

  STRIPE_PUBLIC_KEY = PROD
    ? "pk_live_51OKHeAEzhinWlLgpqGByQoGGofTJF9Fdh6Gvav7mQ8lkYjjYrpqvsaDQeZtxgAJkNt5nCQCAxE40rGPrLxob6Gg9002A6nesis"
    : "pk_test_51OIXWaEExqqZpguNkWpSB8jEVPFWqT7WoVnjsffSnRO5vyJhzpbyMzDukWyPfnQoRNDdCWnsPF83d4ZSzG55bWYT00lZEYWO7D";

  planId = "1cdeae1eda040176ab2907d0c1783bff";
}

let urls = new UrlConstants();
export default urls;
